<template>
    <div>
        <b-form-group
            :label="field.label"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired,
            }"
        >
            <b-form-input
                v-model="model"
                v-validate="{
                    required: field.isRequired,
                    email: !!field.isEmail,
                    numeric: setIsNumeric,
                    max: setMaxLength,
                    min: setMinLength,
                    alpha_num: field.isAlphaNum ? field.isAlphaNum : false,
                    alpha_spaces: field.isAlpha ? field.isAlpha : false,
                }"
                type="text"
                autocomplete="no"
                :placeholder="field.placeholder"
                :disabled="loading || isDisable"
                :data-vv-name="field.label"
                :maxlength="setMaxLength"
                :class="{
                    'is-invalid': errors.has(field.label),
                }"
                @keypress="keyPress"
                @keyup="keyUp"
            ></b-form-input>
        </b-form-group>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    /*
  |--------------------------------------------------------------------------
  | Component > inject
  |--------------------------------------------------------------------------
  */
    inject: {
        $validator: '$validator',
    }, // End of Component > inject

    /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
    components: {}, // End of Component > components

    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {
        field: {
            type: Object,
            required: true,
        },
    }, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        this.setMinLength = this.field.minLength ? this.field.minLength : 3
        this.setMaxLength = this.field.maxLength ? this.field.maxLength : 50

        if (this.field.isNumeric) {
            if (this.field.key === 'identityInfo.number') {
                let idType =
                    this.$store.state.registration.form.identityInfo.type

                if (idType === 'passport') {
                    this.setNumeric = 'text'
                    this.setIsNumeric = false
                    this.setMinLength = 9
                    this.setMaxLength = 9
                } else {
                    //console.log('idType', idType)

                    this.setNumeric = 'text'
                    this.setIsNumeric = false
                }
            } else {
                this.setNumeric = 'number'
                this.setIsNumeric = true
            }
        } else {
            this.setNumeric = 'text'
            this.setIsNumeric = false
        }

        return {
            value: '',
            isDisable: false,
        }
    }, // End of Component > data

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['loading']),

        model: {
            /**
             * Getter to get value for computed property
             * using props from parent componennt
             *
             * @return {mix}
             */
            get: function () {
                if (this.field.isLocked) {
                    return this.$store.getters.getField(this.field.key)
                } else {
                    let customInfo = this.$store.getters.getField(`customInfo`)
                    return customInfo[this.field._id]
                        ? customInfo[this.field._id].value
                        : null
                }
            }, // End of get() method
            /**
             * Setter to set value for computed property
             * notifying the parent component
             *
             * @return {void}
             */
            set: function (newValue) {
                this.value = newValue
                if (this.field.isLocked) {
                    this.$store.commit('updateField', {
                        key: this.field.key,
                        value: newValue,
                    })
                } else {
                    this.$store.commit('updateField', {
                        key: `customInfo.${this.field._id}`,
                        value: {
                            title: this.field.label,
                            type: this.field.type,
                            value: newValue,
                        },
                    })
                }
            }, // End of set() method
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > Created
    |--------------------------------------------------------------------------
    */
    created() {
        if (this.field.key == 'occupationInfo.taxNo') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.basicInfo
                        .taxStatus // could also put a Getter here
                },
                (newValue, oldValue) => {
                    if (newValue == 'Non-Filer') {
                        // this.isDisable = true
                        this.field.isRequired = false
                        this.writeValue('')
                        console.log(
                            'Console Value of Tax No' +
                                this.$store.state.registration.form
                                    .occupationInfo.taxNo
                        )
                    } else {
                        this.isDisable = false
                        this.field.isRequired = true
                    }
                },
                //Optional Deep if you need it
                {
                    deep: true,
                }
            )
        }
        if (this.field.key == 'accountInfo.operateAccountOther') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.accountInfo
                        .operateAccount // could also put a Getter here
                },
                (newValue, oldValue) => {
                    if (newValue == 'Others') {
                        this.isDisable = false
                        this.field.isRequired = true
                        // this.writeValue('')
                    } else {
                        this.isDisable = true
                        this.field.isRequired = false
                    }
                }
            )
        }
        /*
        | -------------------------------------------
        | NTN is equal to IDENTITY NUMBER 
        | -------------------------------------------
        */
        if (this.field.key == 'identityInfo.number') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.identityInfo
                        .number // could also put a Getter here
                },
                (newValue, oldValue) => {
                    //console.log('Identity Number : ' + newValue)
                    this.$store.commit('updateField', {
                        key: 'occupationInfo.taxNo',
                        value: newValue,
                    })
                }
            )
        } // End
    }, // End Component > Created
    mounted() {
        if (this.field.key == 'accountInfo.operateAccountOther') {
            this.isDisable = true
        }
        // initialize if custom field
        if (!this.field.isLocked) {
            this.$store.commit('initCustomField', {
                key: `${this.field._id}`,
                value: {
                    title: this.field.label,
                    type: this.field.type,
                    value: null,
                },
            })
        }
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        keyUp() {
            /*
            | -------------------------------------------
            | Expected Credit field is in Amount
            | -------------------------------------------
            */
            if (this.field.key == 'accountInfo.expectedCredit') {
                let b = this.value
                if (!b.length) {
                    b = null
                } else {
                    let x = b.replace(/\D/g, '')
                    //console.log('X : ' + x)
                    if (x) {
                        let y = parseInt(x).toLocaleString()
                        //console.log('Y : ' + y)
                        this.writeValue(y)
                    } else {
                        this.writeValue(null)
                    }
                }
            } // End Expected Credit field is in Amount
        }, // End KeyUp
        keyPress(event) {
            /*
            | -------------------------------------------
            | Numeric Field (Only Numeric Allow)
            | -------------------------------------------
            */
            if (this.field.isNumeric) {
                event = event ? event : window.event
                let charCode = event.which ? event.which : event.keyCode
                if (
                    charCode > 31 &&
                    (charCode < 48 || charCode > 57) &&
                    charCode !== 46
                ) {
                    event.preventDefault()
                } else {
                    return true
                }
            } // End Numeric Field
        }, // End KeyPress
        numeric() {
            if (this.field.key == 'identityInfo.number') {
                console.log(
                    'ID NO Validation: ' +
                        JSON.stringify(
                            this.$store.state.registration.form.identityInfo
                                .type
                        )
                )

                return false
            } else {
                return !!this.field.isNumeric
            }
        },
        writeValue(newValue) {
            this.value = newValue
            if (this.field.isLocked) {
                this.$store.commit('updateField', {
                    key: this.field.key,
                    value: newValue,
                })
            } else {
                this.$store.commit('updateField', {
                    key: `customInfo.${this.field._id}`,
                    value: {
                        title: this.field.label,
                        type: this.field.type,
                        value: newValue,
                    },
                })
            }
        },
    }, // End of Component > mounted
}
</script>
